export enum CustomerListStatus {
  CREATED = 'CREATED',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED'
}
